import { generateUtilityClass, generateUtilityClasses, unstable_composeClasses as composeClasses } from '@mui/material';

export function getLayoutUtilityClass(slot: string) {
  return generateUtilityClass('O2Layout', slot);
}

const layoutClasses = generateUtilityClasses('O2Layout', ['root', 'content', 'content-box']);

export default layoutClasses;

export const useLayoutUtilityClasses = () => {
  return composeClasses(
    {
      root: ['root'],
      content: ['content'],
      'content-box': ['content-box'],
    },
    getLayoutUtilityClass,
    undefined
  );
};
